import { useEffect, useState } from "react";
import { InputGroup, Alert, Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchShopProductButtonBuy } from "../actions/shopActions";
import { addProductCart, updateProductCart } from "../actions/cartActions";
import { deleteItemCart } from "../actions/cartActions";
import Loading from "./Loading";
import { RootState } from "../reducers";
import { TrashFill, Cart4 } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";

interface Props {
  productId: number;
}

const ProductButtonsBuy = (props: Props) => {
  const { productId } = props;
  const [productIdState, setProductIdState] = useState(productId);
  const [isLoadingAdd, setIsLoadingAdd] = useState(false);
  const product = useSelector(
    (state: RootState) => state.shop.product[productIdState]
  );
  const typesSizes = useSelector(
    (state: RootState) => state.shop.typesSizes[productIdState]
  );
  const pathImages = useSelector(
    (state: RootState) => state.shop.pathImages[productIdState]
  );
  const itemsCart = useSelector((state: RootState) => state.cart.itemsCart);
  const alertMessage = useSelector(
    (state: RootState) => state.cart.alertMessage
  );
  const [quantity, setQuantity] = useState(1);
  const dispatch: any = useDispatch();
  const navigate: any = useNavigate();

  const onAddProductCart = (request: any) => {
    dispatch(addProductCart(request));
  };

  const onUpdateProductCart = (request: any) => {
    dispatch(updateProductCart(request));
  };

  const onFetchShopProductButtonBuy = (id: number) => {
    dispatch(fetchShopProductButtonBuy(id));
  };

  useEffect(() => {
    onFetchShopProductButtonBuy(productIdState);
    // eslint-disable-next-line
  }, [itemsCart]);

  useEffect(() => {
    setIsLoadingAdd(false);
    onFetchShopProductButtonBuy(productIdState);
    // eslint-disable-next-line
  }, [alertMessage]);

  useEffect(() => {
    product?.cantCart && setQuantity(product.cantCart);
    setIsLoadingAdd(false);
  }, [product]);

  const handleChangeSize = (element: any) => {
    setIsLoadingAdd(false);
    setQuantity(1);
    setProductIdState(element.target.value);
    onFetchShopProductButtonBuy(element.target.value);
  };

  const handleSetQuantity = (element: any) => {
    setIsLoadingAdd(false);
    setQuantity(+element.target.value);
  };

  const onDeleteItemCart = (id: string) => {
    setIsLoadingAdd(true);
    dispatch(deleteItemCart(id));
  };

  const handleSubmit = async () => {
    const id = product?.id;
    const name = product?.name;
    const price = product?.price_wholesale;
    const image = pathImages[0] || null;
    const cantCart = product?.cantCart;
    const rowId = product?.rowId;
    if (quantity !== cantCart) {
      setIsLoadingAdd(true);
      if (cantCart) {
        onUpdateProductCart({
          rowId,
          name,
          price,
          image,
          quantity,
        });
      } else {
        onAddProductCart({
          id,
          name,
          price,
          image,
          quantity,
        });
      }
    }
  };

  return product ? (
    <div>
      {typesSizes?.length > 0 && (
        <InputGroup className="mb-3">
          <InputGroup.Text id="inputGroup-sizing-default">
            Elegir talle:
          </InputGroup.Text>
          <Form.Select defaultValue={product.id} onChange={handleChangeSize}>
            {typesSizes.map((type: any, index: number) => {
              return (
                <option key={index} value={type.pivot.product_id}>
                  {type.name}
                </option>
              );
            })}
          </Form.Select>
        </InputGroup>
      )}
      {product.stock > 0 && (
        <div className="row mb-2 mt-2">
          <div className="col-4 text-end">
            <Form.Select
              name="quantity"
              id="quantity"
              value={quantity}
              onChange={handleSetQuantity}
            >
              {Array.from({ length: product.stock }, (_, i) => (
                <option key={i + 1} value={i + 1}>
                  {i + 1}
                </option>
              ))}
            </Form.Select>
          </div>
          <div className="col-8 d-flex justify-content-end">
            {product.cantCart === 0 ? (
              <Button
                variant="success"
                onClick={handleSubmit}
                disabled={isLoadingAdd}
              >
                {isLoadingAdd ? "Agregando..." : "Agregar"}
              </Button>
            ) : (
              <>
                <Button
                  variant="light me-1"
                  onClick={handleSubmit}
                  disabled={isLoadingAdd}
                  size="sm"
                >
                  {isLoadingAdd ? "Modificando..." : "Modificar"}
                </Button>
                {itemsCart > 0 && (
                  <Button
                    onClick={() => navigate("/cart")}
                    variant="light me-1"
                  >
                    <Cart4 size={15} />
                    {itemsCart}
                  </Button>
                )}
                <Button
                  variant="danger"
                  onClick={() => onDeleteItemCart(product.rowId)}
                  size="sm"
                >
                  <TrashFill size={15} />
                </Button>
              </>
            )}
          </div>
        </div>
      )}
      {product.stock === 0 && (
        <Alert variant="info">
          Sin stock, se acaba de vender la última unidad de este talle.
        </Alert>
      )}
    </div>
  ) : (
    <Loading />
  );
};

export default ProductButtonsBuy;
